<a [routerLink]="item.path" routerLinkActive="active">{{item.name | uppercase}}</a>
